import React from 'react';
import "./index.css";

const Loader = (props) => {
    return (
        <div className={props.className ? `loader ${props.className}` : 'loader'} />
    );
};

export default Loader;